// removed by extract-text-webpack-plugin
module.exports = {"OrderTabItem":"wmf-2MkI3kAR"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/udeskSide/components/OrderTabItem.module.less
// module id = 955
// module chunks = 0